import type { CompanyProfile, Invoice } from '@/types'

interface PartiesBlockProps {
	invoice: Invoice
	company?: CompanyProfile | null
}

/**
 * Supplier / Buyer / Basis rows under the invoice header. Two-column layout:
 * label on the left, value on the right.
 */
function formatBasis(invoice: Invoice): string {
	if (!invoice.basisDocNumber && !invoice.basisDocDate) return '—'
	const parts = [
		invoice.basisDocNumber && `№ ${invoice.basisDocNumber}`,
		invoice.basisDocDate   && `от ${new Date(invoice.basisDocDate).toLocaleDateString('ru-RU')}`,
	].filter(Boolean)
	return parts.join(' ')
}

export function PartiesBlock({ invoice, company }: PartiesBlockProps) {
	const supplierLine = company
		? [
			company.name,
			company.inn && `ИНН ${company.inn}`,
			company.kpp && `КПП ${company.kpp}`,
			company.address,
		].filter(Boolean).join(', ')
		: '—'

	const buyerLine = invoice.tenantName
		? [
			invoice.tenantName,
			invoice.tenantInn && `ИНН ${invoice.tenantInn}`,
			invoice.tenantKpp && `КПП ${invoice.tenantKpp}`,
			invoice.tenantAddress ?? invoice.propertyAddress,
		].filter(Boolean).join(', ')
		: '—'

	return (
		<dl className="grid grid-cols-[120px_1fr] gap-y-3 text-xs">
			<dt className="text-(--color-muted-foreground)">Поставщик<br />(Исполнитель):</dt>
			<dd>{supplierLine}</dd>

			<dt className="text-(--color-muted-foreground)">Покупатель<br />(Заказчик):</dt>
			<dd>{buyerLine}</dd>

			<dt className="text-(--color-muted-foreground)">Основание:</dt>
			<dd>{formatBasis(invoice)}</dd>
		</dl>
	)
}
